"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var tokenProvider_1 = __importDefault(require("../../config/tokenProvider"));
var ramda_1 = require("ramda");
var selectors_1 = require("../../modules/auth/selectors");
var selectors_2 = require("../../modules/customer/selectors");
var constants_1 = require("../../modules/auth/constants");
var config_1 = __importDefault(require("../../config"));
var axiosClient_1 = __importDefault(require("./clients/axiosClient"));
var graphQLClient_1 = __importDefault(require("./clients/graphQLClient"));
var types_1 = require("./types");
var handlers_1 = require("./handlers");
var racing_1 = __importStar(require("./racing"));
var logging_1 = __importDefault(require("../../logging"));
var callApi = function (_a) {
    var baseURL = _a.baseURL, path = _a.path, token = _a.token, profileId = _a.profileId, method = _a.method, params = _a.params, data = _a.data, includeSkyHeaders = _a.includeSkyHeaders, graphQL = _a.graphQL, fetchFunc = _a.fetchFunc, fetchOptions = _a.fetchOptions, authenticated = _a.authenticated, etag = _a.etag;
    return __awaiter(void 0, void 0, void 0, function () {
        var config, appVersion, accToken, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    config = {
                        baseURL: baseURL,
                        method: method,
                        url: path,
                    };
                    if (includeSkyHeaders) {
                        appVersion = logging_1.default.getRelease();
                        config.headers = __assign(__assign(__assign({ 'x-session-id': logging_1.default.getSessionId() }, (!ramda_1.isNil(appVersion) ? { 'x-sky-app-version': appVersion } : {})), { 'x-sky-device-id': logging_1.default.getDeviceId(), 'x-sky-app-id': logging_1.default.getAppId(), 'x-correlation-id': logging_1.default.getCorrelationId(), 'x-product-id': config_1.default.PRODUCT_ID }), ((logging_1.default === null || logging_1.default === void 0 ? void 0 : logging_1.default.getUserAgent) ? { 'user-agent': logging_1.default.getUserAgent() } : {}));
                        if (etag) {
                            config.headers['If-None-Match'] = etag;
                        }
                    }
                    if (!authenticated) return [3 /*break*/, 7];
                    accToken = void 0;
                    if (!tokenProvider_1.default.getAccessToken) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, tokenProvider_1.default.getAccessToken()];
                case 2:
                    accToken = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    return [2 /*return*/, Promise.resolve(racing_1.CANCEL_RESPONSE)];
                case 4: return [3 /*break*/, 6];
                case 5:
                    if (token) {
                        accToken = token;
                    }
                    _b.label = 6;
                case 6:
                    if (accToken) {
                        config.headers = __assign(__assign({}, config.headers), { Authorization: "Bearer " + accToken });
                    }
                    _b.label = 7;
                case 7:
                    if (profileId) {
                        config.headers = __assign(__assign({}, config.headers), { 'x-user-profile': profileId });
                    }
                    config.fetchOptions = __assign({ credentials: 'include', jsonSerializer: JSON, method: method }, fetchOptions);
                    config.params = params;
                    config.data = data;
                    if (fetchFunc) {
                        return [2 /*return*/, fetchFunc(config)];
                    }
                    return [2 /*return*/, graphQL ? graphQLClient_1.default(config) : axiosClient_1.default(config)];
            }
        });
    });
};
var dispatchActionsForApiCall = function (dispatch, getState, apiAction) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, requestType, successType, errorType, cancelType, baseURL, path, method, params, data, meta, _b, graphQL, _c, authenticated, _d, includeSkyHeaders, _e, includeProfileId, _f, onlyLatest, _g, hasResponseData, _h, onRequest, _j, onSuccess, _k, onError, _l, auth, fetchFunc, _m, fetchOptions, etagSelector, state, token, profileId, requestAction, callApiFunc, response, cancelAction, errorResponse_1, requestParams;
    var _o, _p, _q;
    return __generator(this, function (_r) {
        switch (_r.label) {
            case 0:
                _a = apiAction.actionTypes, requestType = _a[0], successType = _a[1], errorType = _a[2], cancelType = _a[3], baseURL = apiAction.baseURL, path = apiAction.path, method = apiAction.method, params = apiAction.params, data = apiAction.data, meta = apiAction.meta, _b = apiAction.graphQL, graphQL = _b === void 0 ? false : _b, _c = apiAction.authenticated, authenticated = _c === void 0 ? false : _c, _d = apiAction.includeSkyHeaders, includeSkyHeaders = _d === void 0 ? true : _d, _e = apiAction.includeProfileId, includeProfileId = _e === void 0 ? true : _e, _f = apiAction.onlyLatest, onlyLatest = _f === void 0 ? false : _f, _g = apiAction.hasResponseData, hasResponseData = _g === void 0 ? true : _g, _h = apiAction.onRequest, onRequest = _h === void 0 ? function () { return undefined; } : _h, _j = apiAction.onSuccess, onSuccess = _j === void 0 ? function () { return undefined; } : _j, _k = apiAction.onError, onError = _k === void 0 ? function () { return undefined; } : _k, _l = apiAction.auth, auth = _l === void 0 ? {
                    tokenSelector: selectors_1.accessToken,
                    profileIdSelector: selectors_2.selectedProfileId,
                    errorActionType: constants_1.UNAUTHORIZED_ERROR,
                } : _l, fetchFunc = apiAction.fetchFunc, _m = apiAction.fetchOptions, fetchOptions = _m === void 0 ? {} : _m, etagSelector = apiAction.etagSelector;
                state = getState();
                token = (_o = (authenticated && auth.tokenSelector(state))) !== null && _o !== void 0 ? _o : '';
                profileId = (_q = (includeProfileId && ((_p = auth.profileIdSelector) === null || _p === void 0 ? void 0 : _p.call(auth, state)))) !== null && _q !== void 0 ? _q : '';
                onRequest(dispatch, { meta: meta });
                requestAction = { type: requestType, meta: meta };
                dispatch(requestAction);
                _r.label = 1;
            case 1:
                _r.trys.push([1, 3, , 4]);
                callApiFunc = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, callApi({
                                baseURL: baseURL,
                                path: path,
                                token: token,
                                profileId: profileId,
                                method: method || (graphQL ? types_1.HTTPMethod.POST : types_1.HTTPMethod.GET),
                                params: params,
                                data: data,
                                includeSkyHeaders: includeSkyHeaders,
                                graphQL: graphQL,
                                fetchFunc: fetchFunc,
                                fetchOptions: fetchOptions,
                                authenticated: authenticated,
                                etag: (_a = etagSelector === null || etagSelector === void 0 ? void 0 : etagSelector(state)) === null || _a === void 0 ? void 0 : _a.etag,
                            })];
                    });
                }); };
                return [4 /*yield*/, (onlyLatest ? racing_1.default(cancelType, callApiFunc) : callApiFunc())];
            case 2:
                response = _r.sent();
                if (response === racing_1.CANCEL_RESPONSE) {
                    cancelAction = { type: cancelType, meta: meta };
                    return [2 /*return*/, dispatch(cancelAction)];
                }
                // if request succeeds, dispatch the provided success action
                return [2 /*return*/, handlers_1.successHandler(dispatch, response, successType, errorType, meta, onSuccess, onError, hasResponseData)];
            case 3:
                errorResponse_1 = _r.sent();
                requestParams = graphQL
                    ? " -gql:" + JSON.stringify(params)
                        .replace(/\s|\\n/g, '')
                        .slice(0, 80)
                    : "-path:" + path;
                return [2 /*return*/, handlers_1.errorHandler(dispatch, errorResponse_1, successType, errorType, auth.errorActionType, meta, onError, requestParams)];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.default = (function (store) { return function (next) { return function (action) {
    var apiAction = action[types_1.CALL_API];
    // if the current action does not have a CALL_API property, let the dispatch chain continue
    if (apiAction === undefined) {
        return next(action);
    }
    return dispatchActionsForApiCall(store.dispatch, store.getState, apiAction);
}; }; });
//# sourceMappingURL=index.js.map